import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import { submitPackagingSolutions } from "@/api/import-api";

type SubmitPackagingSolutionVariables = unknown[];

export const useSubmitPackagingSolution = (
	mutationConfig: Omit<UseMutationOptions<void, Error, SubmitPackagingSolutionVariables>, "mutationFn"> = {},
) => {
	return useMutation({
		mutationFn: submitPackagingSolutions,
		...mutationConfig,
	});
};
